var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],class:{
    'grey': _vm.grey,
    'mobile': _vm.isMobile,
    'mobile-fullheight': _vm.mobileFullHeight
  }},[_c('nprogress-container'),_c('header-bar'),_c('main',[_c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut","appear":""}},[_c('router-view',{staticClass:"router-view animated"})],1)],1),(!_vm.mobileFullHeight)?_c('footer-bar'):_vm._e(),_c('login-modal'),_c('snackbar'),_c('whatsapp-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }